import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TmcYardCommonModule } from 'src/tmc-yard/common/common.module';
import { ApplicationClientCommonModule, MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { CEPTabletWidgetComponent } from './component/cep-tablet-widget.component';
import { CEPTabletModule } from 'src/tmc-yard/control/cep-tablet/cep-tablet.module';
import { TransportDetailsModule } from 'src/tmc-yard/common/components/transport-details/transport-details.module';

@NgModule({
  declarations: [
    CEPTabletWidgetComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    CommonLayoutModule,
    CommonUIModule,
    ReactiveFormsModule,
    FormsModule,
    TmcYardCommonModule,
    TransportDetailsModule,
    ServiceResponseModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    CEPTabletModule
  ]
})
export class CEPTabletWidgetModule { }
